/* eslint-disable no-plusplus */
import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import { MasonryDiv, Col } from './styles'

Masonry.propTypes = {
  children: PropTypes.node.isRequired,
  gap: PropTypes.string.isRequired,
  minWidth: PropTypes.number
}

Masonry.defaultProps = {
  minWidth: 300
}

export default function Masonry({ children, gap, minWidth = 300 }) {
  const cols = []
  const ref = useRef()
  const [numCols, setNumCols] = useState(3)

  const calcNumCols = () =>
    setNumCols(Math.floor(ref.current.offsetWidth / minWidth) || 1)

  const createCols = () => {
    for (let i = 0; i < numCols; i++) cols[i] = []
    children.map((child, i) => cols[i % numCols].push(child))
  }

  useEffect(() => {
    calcNumCols()
    window.addEventListener('resize', calcNumCols)
    return () => window.removeEventListener('resize', calcNumCols)
  })

  createCols()

  return (
    <MasonryDiv ref={ref} gap={gap}>
      {Array(numCols)
        .fill()
        .map((_, i) => (
          <Col key={shortid.generate()} gap={gap}>
            {cols[i]}
          </Col>
        ))}
    </MasonryDiv>
  )
}
